module.exports = __webpack_public_path__ + "static/media/profile-page.ed812899.png";